import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ index, eyebrow, title, center = false }) => (
    <div className={center ? "text-center" : ""}>
        <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold">
                {index} — {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.12}>
            <h2 className="mt-5 font-serif text-3xl sm:text-5xl leading-[1.08] tracking-tight text-cream">
                {title}
            </h2>
        </Reveal>
    </div>
);
